export function getPath(state) {
	var fullPath = "/owl_shop";

	if (state.activeView) {
		fullPath += "/" + state.activeView;
	}

	return fullPath;
}

export function getRouteState(params) {
	var state = {};

	if (params.active_view) {
		state.activeView = params.active_view;
	} else {
		state.activeView = VIEWS.SHOP;
	}
	
	return state;
}

export var PATH = "/owl_shop/:active_view?";

export var VIEWS = {
	SHOP: "shop",
	PHOTOS: "photos",
}


// WEBPACK FOOTER //
// ./modules/lib/routing/OwlShopRouting.js